import { render, staticRenderFns } from "./SetPayment.vue?vue&type=template&id=67e831ac&"
import script from "./SetPayment.vue?vue&type=script&lang=js&"
export * from "./SetPayment.vue?vue&type=script&lang=js&"
import style0 from "./SetPayment.vue?vue&type=style&index=0&id=67e831ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports